import TestSelectors from '@racemap/utilities/consts/test_selectors';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import { Button, Flex, Result } from 'antd';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { checkLeaderboardActivationState } from 'src/components/Leaderboard/utils';

export const LeaderboardErrorPage: FC<{ event: Immutable<RacemapEvent> | undefined | null }> = ({
  event,
}) => {
  if (!event) return null;
  const { isArchived, isModuleActivated } = checkLeaderboardActivationState(event);

  if (isArchived) {
    return (
      <Flex
        align="center"
        justify="center"
        vertical
        style={{ height: '100%' }}
        className={TestSelectors.leaderboard.errorPage.container.toString()}
        id={TestSelectors.leaderboard.errorPage.archivedResult.toString()}
      >
        <Result
          status={403}
          title="Leaderboard is archived!"
          extra={
            <Button type="primary" href="https://racemap.com">
              Back Home
            </Button>
          }
        />
      </Flex>
    );
  }

  if (!isModuleActivated) {
    return (
      <Flex
        align="center"
        justify="center"
        vertical
        style={{ height: '100%' }}
        className={TestSelectors.leaderboard.errorPage.container.toString()}
        id={TestSelectors.leaderboard.errorPage.notActivatedResult.toString()}
      >
        <Result
          status={403}
          title="Leaderboard module is not activated!"
          extra={
            <Button type="primary" href="https://racemap.com">
              Back Home
            </Button>
          }
        />
      </Flex>
    );
  }

  return null;
};
